// Opportunity stages (Opportunities › Stage), shared by the commercial screens and the person card.
// Pure: no browser globals, so the server tests can import it.
export const OPP_STAGES     = ['Prospecting', 'Qualification', 'Discovery', 'Proposal', 'Negotiation', 'Closed Won', 'Closed Lost', 'On Hold'];
export const WON_STAGES     = ['Closed Won', 'Closed/Won', 'Cierre ganado'];
export const CLOSED_STAGES  = [...WON_STAGES, 'Closed Lost', 'Closed/Lost', 'Closed/Canceled', 'Cierre perdido'];
